import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import './language-selector.scss';

const LanguageSelector = ({ content, currentLang, currentGame }) => {
  /**
   * Renders Language Options
   * @returns {[React.Component]}
   */
  const renderLanguages = () => content.map((language, i) => {
    const classList = classnames('lang-item', language, { active: language === currentLang });

    return (
      <Link key={i} to={`/${language}`} className={classList} state={{ currentGame }}>
        {language.toUpperCase()}
        <FontAwesomeIcon className="btn-arrow" icon={faCheck} />
      </Link>
    )
  });

  return (
    <div className="language-selector">
      <p className="selected-language">
        {currentLang.toUpperCase()}
        <FontAwesomeIcon className="btn-arrow" icon={faAngleDown} />
      </p>
      <div className="language-wrapper">
        {renderLanguages()}
      </div>
    </div>
  );
};

LanguageSelector.propTypes = {
  content: PropTypes.array.isRequired,
  currentLang: PropTypes.string.isRequired,
};

export default LanguageSelector;
